<template>
	<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
		width="24px" height="24px"
		viewBox="0 0 512 512"  xml:space="preserve">
	<g>
		<path fill="currentColor" d="M56.007,114.35c-5.535-5.539-14.51-5.539-20.045,0L4.148,146.159c-5.531,5.539-5.531,14.506,0,20.046
			l20.622,20.621l51.859-51.855L56.007,114.35z"/>
		<polygon fill="currentColor" points="286.422,396.623 268.742,327.077 216.884,378.94 	"/>
		<path fill="currentColor" d="M258.136,316.475L86.058,144.397L34.2,196.26l172.073,172.077L258.136,316.475z M87.468,166.56
			l149.919,149.922l-11.784,11.78L75.684,178.348L87.468,166.56z"/>
		<rect x="195.662" y="132.491" fill="currentColor" width="29.356" height="28.017"/>
		<rect x="195.662" y="200.693" fill="currentColor" width="29.356" height="28.009"/>
		<rect x="256.69" y="132.491" fill="currentColor" width="173.056" height="28.017"/>
		<rect x="256.69" y="200.693" fill="currentColor" width="173.056" height="28.009"/>
		<rect x="288.598" y="268.894" fill="currentColor" width="141.148" height="28.01"/>
		<path fill="currentColor" d="M429.817,11.059H195.582c-45.32,0-82.182,36.858-82.182,82.179v32.726l30.427,30.435V93.238
			c0-28.586,23.178-51.752,51.755-51.752h234.235c28.594,0,51.756,23.166,51.756,51.752v254.042h-80.097
			c-23.822,0-43.124,19.318-43.124,43.132v80.101h-162.77c-28.578,0-51.755-23.166-51.755-51.752v-37.072l-6.234-1.587l6.234-6.235
			v-22.202L113.4,321.239v97.522c0,45.313,36.862,82.179,82.182,82.179h162.77h12.598l8.917-8.913l123.224-123.224l8.909-8.912
			v-12.61V93.238C512,47.917,475.138,11.059,429.817,11.059z"/>
	</g>
	</svg>
</template>